import { render } from "./StartButton.vue?vue&type=template&id=32672c90&scoped=true"
import script from "./StartButton.vue?vue&type=script&lang=js"
export * from "./StartButton.vue?vue&type=script&lang=js"

import "./StartButton.vue?vue&type=style&index=0&id=32672c90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32672c90"]])

export default __exports__